export default "__VITE_ASSET__B9um$$dY__"